import { combineReducers } from "redux";
import blogsReducer from "../blogs/blogsReducer";
import filterReducer from "../filter/filterReducer";
export const rootReducer = combineReducers({
    filter: filterReducer,
    allBlogs: blogsReducer,
});
